import React from 'react'
import { Header as BaseHeader } from 'components/Header'
import { Flex, Heading, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'

export const Header = () => {
  return (
    <BaseHeader
      title={
        <Flex gap={2} flexDirection="column">
          <Heading level={1} style={{ margin: 0 }} fontWeight="400">
            Create Shifts
          </Heading>
          <Text color="lightText" fontSize={2}>
            Template:{' '}
            <Link
              to="https://docs.google.com/spreadsheets/d/1kACM-fh6MmcLDZW4csTWsiSQtbbrTNIeFFBtOrotfsc"
              target="_blank"
            >
              https://docs.google.com/spreadsheets/d/1kACM-fh6MmcLDZW4csTWsiSQtbbrTNIeFFBtOrotfsc
            </Link>
          </Text>
        </Flex>
      }
    />
  )
}
